import { axiosObject } from "../config";

export default function getPYPData(id: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/posted_properties/_read";
    let payload = {
      apiConfig: {
        includeRelations: "*",
        includeMutations: "*",
      },
      limitBy: {
        per_page: 1,
        page: 1,
      },
      sortBy: [],
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: id,
        },
        {
          attribute: "deleted_at",
          op: "is",
          value: null,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
